var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'asc-global-filter-button',
    _vm.filterDisabled ? 'asc-global-filter-button--disabled' : '' ]},[_c('asc-tooltip',{attrs:{"bottom":"","tooltip":_vm.getTooltip,"tooltip-length":0}},[_c('asc-accent-button',{class:[
        _vm.filterEnabled && _vm.filterActive
          ? 'asc-global-filter-button--enabled-active'
          : '',
        _vm.filterEnabled && !_vm.filterActive
          ? 'asc-global-filter-button--enabled'
          : '' ],attrs:{"on-click":_vm.onClick,"button-text":_vm.buttonText,"disabled":_vm.filterDisabled,"secondary":"","icon":_vm.getButtonIcon,"icon-position":"right"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }